import {
  AlertCircle,
  ArrowLeft,
  ArrowUp,
  Award,
  BookOpen,
  Brain,
  BriefcaseBusiness,
  Building2,
  CalendarDays,
  Camera,
  CheckCircle2,
  ChevronDown,
  ChevronRight,
  CircleX,
  ChevronUp,
  CircleHelp,
  Clock3,
  Coffee,
  Compass,
  ExternalLink,
  Eye,
  FileText,
  Globe2,
  GraduationCap,
  Heart,
  Info,
  Keyboard,
  Layers3,
  Lightbulb,
  LoaderCircle,
  LogOut,
  type LucideIcon,
  MapPin,
  MessageCircle,
  MessageSquare,
  Monitor,
  PanelLeftClose,
  Pencil,
  PencilLine,
  Plus,
  Search,
  Settings,
  SlidersHorizontal,
  Square,
  SquarePen,
  Star,
  Target,
  UserCog,
  Users,
  X
} from 'lucide-react';
import type { CSSProperties } from 'react';

import InternetGlobeIcon from '@/components/icons/InternetGlobeIcon';

interface MaterialIconProps {
  name: string;
  className?: string;
  filled?: boolean;
  size?: number | string;
  title?: string;
  style?: CSSProperties;
}

/**
 * Compatibility map for the old Material Symbols names used throughout the
 * rebrand. The icons are bundled with the application, so navigation does not
 * disappear when Google Fonts is blocked or unavailable.
 */
const ICONS: Record<string, LucideIcon> = {
  add: Plus,
  apartment: Building2,
  arrow_back: ArrowLeft,
  arrow_upward: ArrowUp,
  award: Award,
  calendar_month: CalendarDays,
  cancel: CircleX,
  chat: MessageCircle,
  chat_bubble: MessageSquare,
  check_circle: CheckCircle2,
  keyboard_arrow_down: ChevronDown,
  keyboard_arrow_up: ChevronUp,
  chevron_right: ChevronRight,
  close: X,
  coffee: Coffee,
  computer: Monitor,
  description: FileText,
  edit: Pencil,
  edit_note: PencilLine,
  edit_square: SquarePen,
  error: AlertCircle,
  explore: Compass,
  favorite: Heart,
  group: Users,
  help: CircleHelp,
  info: Info,
  keyboard: Keyboard,
  layers: Layers3,
  left_panel_close: PanelLeftClose,
  lightbulb: Lightbulb,
  location_on: MapPin,
  logout: LogOut,
  manage_accounts: UserCog,
  memory: Brain,
  menu_book: BookOpen,
  open_in_new: ExternalLink,
  photo_camera: Camera,
  progress_activity: LoaderCircle,
  public: Globe2,
  schedule: Clock3,
  school: GraduationCap,
  search: Search,
  settings: Settings,
  star: Star,
  stop: Square,
  target: Target,
  tune: SlidersHorizontal,
  visibility: Eye,
  web_source: InternetGlobeIcon,
  work: BriefcaseBusiness
};

export default function MaterialIcon({
  name,
  className = '',
  filled = false,
  size,
  title,
  style: externalStyle
}: MaterialIconProps) {
  const Icon = ICONS[name] || CircleHelp;
  const dimension = size || '1em';
  return (
    <Icon
      className={className}
      width={dimension}
      height={dimension}
      strokeWidth={filled ? 2.5 : 2}
      style={externalStyle}
      aria-hidden="true"
      data-icon-title={title}
    />
  );
}
